export default {
  methods: {
    relationDeleted(uuid, leadingEventItem, secondEventItem) {
      if (leadingEventItem || secondEventItem) {
        return;
      }

      this.$emit('relationDeleted', uuid);
    },
  },
};
